import { CampagneFichierDto, CampagneFichierType, Page, useGetCampagneFichiersQuery } from '@common/services';
import { groupBy } from '@common/utils';

export function useCampagneFichiers(args: UseCampagneFichiersConfig) {
  const { campagneId } = args;

  const { data: fichiers = [] as Page<CampagneFichierDto>, isLoading } = useGetCampagneFichiersQuery(
    { campagneId },
    { skip: !campagneId },
  );

  const filesMap = groupBy<CampagneFichierType, CampagneFichierDto>('type', fichiers.content);

  return {
    filesMap,
    isLoading,
  };
}

interface UseCampagneFichiersConfig {
  campagneId?: number;
}